var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTravelColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TravelColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.1096196,2.48608411 C75.8480229,-0.82867419 85.151978,-0.828704708 90.8903813,2.48605359 L156.696167,40.498108 C159.785645,42.282715 161.211792,44.6642762 160.97461,47.0000001 L161,47.0000001 L161,82.0000001 L160.97461,82.0000001 C160.771241,84.0027162 159.345093,85.9717408 156.696167,87.5018922 L90.8903813,125.513947 C85.151978,128.828705 75.8480229,128.828705 70.1096196,125.513947 L4.30383344,87.5018922 C1.65490766,85.9717408 0.228760202,84.0027162 0.0253910613,82.0000001 L4.36335995e-07,82.0000001 L4.36335995e-07,47.0000001 L0.0253910613,47.0000001 C-0.211791556,44.6642762 1.21435591,42.282715 4.30383344,40.498108 L70.1096196,2.48608411 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 0,
    width: 80.0502777,
    height: 84.5474854
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.7837917%",
    y1: "46.6292169%",
    x2: "51.6181755%",
    y2: "52.2471952%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.8760609%",
    y1: "46.6292169%",
    x2: "58.147953%",
    y2: "52.2471952%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.7059352%",
    y1: "46.6292169%",
    x2: "62.3658322%",
    y2: "52.2471952%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.6518556%",
    y1: "46.6292169%",
    x2: "83.7259215%",
    y2: "52.2471952%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.9358085%",
    y1: "46.6292169%",
    x2: "55.4074413%",
    y2: "52.2471952%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.5000004,1.25950464e-07 C84.3971581,1.25950464e-07 88.134695,0.894265346 90.8903966,2.48606797 L156.69617,40.4980963 C159.451872,42.0898989 161,44.2488477 161,46.5000001 C161,48.7511457 159.451872,50.9100942 156.69617,52.5018971 L90.8903897,90.5139237 C88.1346879,92.1057265 84.3971513,93.0000001 80.5000004,93.0000001 C76.6028496,93.0000001 72.8653196,92.1057401 70.109618,90.5139374 L4.30384041,52.5019005 C1.54813881,50.9100979 4.36335995e-07,48.7511492 4.36335995e-07,46.5000001 C4.36335995e-07,44.2488511 1.54813945,42.089906 4.30384127,40.4981032 L70.109618,2.48606862 C72.8653198,0.894265775 76.6028565,1.25950464e-07 80.5000004,1.25950464e-07 Z M114.899441,26.4166054 C111.845215,24.6579534 107.017566,24.6579535 104.061863,26.4166056 C103.076629,27.0028231 96.3770363,31.008642 87.6084528,36.186896 L47.6750803,28.8283129 C47.4409834,28.7851756 47.1991762,28.8269592 46.9931296,28.9461521 L40.912315,32.4637534 C40.7064211,32.582858 40.5497247,32.7714538 40.4703566,32.9956832 C40.2860737,33.5163158 40.5587391,34.0877627 41.0793716,34.2720455 L72.4358499,45.3709682 C69.0860536,47.3250262 65.8347781,49.2790835 62.6820288,51.1354387 C60.1204201,52.6986852 57.7558583,54.0665272 55.4898197,55.4343678 L45.0645113,54.4858835 C44.8602956,54.4673041 44.6553048,54.5119549 44.4773165,54.6137852 L39.4174795,57.5086093 C39.1636606,57.6538236 38.9861212,57.9028613 38.9316027,58.1901573 C38.8286363,58.7327588 39.1850309,59.256095 39.7276324,59.3590614 L52.5799807,61.7979788 C52.8638325,61.8518438 53.1105155,62.0258436 53.2564995,62.2751666 L57.8467671,70.1147919 C58.123846,70.5880094 58.7303376,70.7498121 59.206313,70.477498 L65.3603968,66.956636 C65.7557731,66.7304341 65.9483214,66.2656192 65.8287224,65.8260902 L64.3569273,60.4172118 C66.7214894,59.1470742 69.1845744,57.7792357 71.8447066,56.3136922 C75.0959793,54.4573371 78.4457765,52.600983 81.894096,50.7446278 L101.943922,69.3907425 C102.265742,69.6900313 102.745245,69.7441306 103.12566,69.5240704 L109.905237,65.6022554 C110.379617,65.3278388 110.544747,64.7227278 110.275517,64.2453857 L97.7563665,42.0490674 C106.919044,36.9685169 113.914207,33.1581052 114.899441,32.5718877 C117.855144,30.9109383 117.855144,28.1752573 114.899441,26.4166054 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TravelColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-123",
    transform: "translate(14.500000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1096191,12.4860832 C75.8480225,9.17132486 85.1519775,9.17129434 90.8903809,12.4860526 L156.696167,50.4981071 C159.785645,52.282714 161.211792,54.6642753 160.974609,56.9999992 L161,56.9999992 L161,91.9999992 L160.974609,91.9999992 C160.77124,94.0027152 159.345093,95.9717399 156.696167,97.5018913 L90.8903809,135.513946 C85.1519775,138.828704 75.8480225,138.828704 70.1096191,135.513946 L4.30383301,97.5018913 C1.65490723,95.9717399 0.228759766,94.0027152 0.025390625,91.9999992 L0,91.9999992 L0,56.9999992 L0.025390625,56.9999992 C-0.211791992,54.6642753 1.21435547,52.282714 4.30383301,50.4981071 L70.1096191,12.4860832 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.699999988,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.3191429,2.37914062 C75.6655257,-0.793046713 84.3337333,-0.793046951 89.680116,2.37914014 L150.989838,38.7562447 C156.336222,41.9284327 156.336222,47.0715637 150.989838,50.2437515 L89.6801096,86.6208572 C84.3337312,89.7930422 75.6655273,89.7930529 70.3191429,86.6208649 L9.00941701,50.2437553 C3.66303387,47.071568 3.66303307,41.9284332 9.00941741,38.7562447 L70.3191429,2.37914062 Z",
    id: "Subtract",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    transform: "translate(77.091078, 67.371442) rotate(-0.000001) translate(-77.091078, -67.371442) translate(37.065939, 25.097699)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Vector",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero",
    mask: "url(#mask-7)",
    points: "10.2527449 3.64174247 10.2527449 42.027676 2.07026583 46.7520978 1.97168183 8.46459109"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    mask: "url(#mask-7)",
    points: "7.68955946 29.5276413 7.68955946 42.9381118 0 47.3672581 0 33.9567875"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Vector",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero",
    mask: "url(#mask-7)",
    points: "27.3077946 35.531596 27.3077946 58.8338203 44.8557606 49.0896962 44.8557606 25.7874756"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero",
    mask: "url(#mask-7)",
    points: "50.4750538 10.6958227 50.4750538 49.5080106 10.2527447 42.027675 10.2527447 3.64174247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero",
    mask: "url(#mask-7)",
    points: "61.0132179 17.13227 61.0132179 55.518208 77.8815193 45.8662729 77.8815193 7.48033571"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelColor);
export default __webpack_public_path__ + "static/media/TravelColor.46850d39e5711cbe639bfee472c48e26.svg";
export { ForwardRef as ReactComponent };